import __request__ from "routing/request";
export function addEntitySharesForPacks(JSONbody, requestOptions) {
  return __request__("POST", "/plugins/org.graylog.plugins.illuminate/illuminate_shares/add", JSONbody, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function addEntityShareForPack(pack_id, user_id, capability, requestOptions) {
  return __request__("GET", "/plugins/org.graylog.plugins.illuminate/illuminate_shares/add_for_pack", null, { "pack_id": pack_id, "user_id": user_id, "capability": capability }, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function getEntities(packId, requestOptions) {
  return __request__("GET", `/plugins/org.graylog.plugins.illuminate/illuminate_shares/entities/${packId}`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function removeEntitySharesForPacks(JSONbody, requestOptions) {
  return __request__("POST", "/plugins/org.graylog.plugins.illuminate/illuminate_shares/remove", JSONbody, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function removeEntityShareForPack(pack_id, user_id, capability, requestOptions) {
  return __request__("DELETE", "/plugins/org.graylog.plugins.illuminate/illuminate_shares/remove_for_pack", null, { "pack_id": pack_id, "user_id": user_id, "capability": capability }, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function updateEntitySharesForPacks(JSONbody, requestOptions) {
  return __request__("POST", "/plugins/org.graylog.plugins.illuminate/illuminate_shares/update", JSONbody, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function getShares(packId, requestOptions) {
  return __request__("GET", `/plugins/org.graylog.plugins.illuminate/illuminate_shares/${packId}`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
